// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3trF8","inputWrap":"styles_inputWrap__BkwbV","input":"styles_input__Xt9Xd"};